export default () => ({
    header: {
        position: 'relative',
        paddingBottom: 21,
        borderBottom: '2px solid #F3F3F3'
    }
});
